import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-raffle" }

import { ref } from "vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatRaffleCountersSection from "./bonusomat-raffle-counters-section.vue";
import useBonusomatAllwynDrawCountdown from "../../composables/use-bonusomat-allwyn-countdown";
import useBonusomatData from "../../composables/use-bonusomat-data";
import useBonusomatDrawCountdown from "../../composables/use-bonusomat-raffle-countdown";
import RafflePrizesModal from "../shared/raffle-prizes-modal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-raffle',
  setup(__props) {

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const { defaultDrawData, isDefaultDrawDataLoaded, allwynDrawData, isAllwynDrawDataLoaded } = useBonusomatData();

const { raffleRemainingSeconds } = useBonusomatDrawCountdown();
const { allwynDrawRemainingSeconds } = useBonusomatAllwynDrawCountdown();

const isModalOpen = ref(false);

const openWinTableModal = async () => {
    isModalOpen.value = true;

    BonusomatDatalayer.pushMoreInfoClick(
        "Ceny v losovačce",
        bonusomatPlayerData.value.points,
        remainingSpinsCount.value
    );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(BonusomatRaffleCountersSection, {
      "has-raffle-data-loading-failed": 
                _unref(isDefaultDrawDataLoaded) && !_unref(defaultDrawData) && _unref(isAllwynDrawDataLoaded) && !_unref(allwynDrawData)
            ,
      "show-default-counters": _unref(defaultDrawData) && _unref(isDefaultDrawDataLoaded),
      "total-win": _unref(defaultDrawData)?.totalWin ?? 0,
      "raffle-remaining-seconds": _unref(raffleRemainingSeconds),
      "show-allwyn-counters": _unref(allwynDrawData) && _unref(isAllwynDrawDataLoaded),
      "allwyn-name": _unref(allwynDrawData)?.name,
      "allwyn-remaining-seconds": _unref(allwynDrawRemainingSeconds),
      "show-tickets-counters": true,
      "raffle-tickets-count": _unref(defaultDrawData)?.playerTickets ?? 0,
      "allwyn-tickets-count": _unref(allwynDrawData)?.playerTickets ?? 0,
      isWidget: false,
      onOpenWinTableModal: openWinTableModal
    }, null, 8, ["has-raffle-data-loading-failed", "show-default-counters", "total-win", "raffle-remaining-seconds", "show-allwyn-counters", "allwyn-name", "allwyn-remaining-seconds", "raffle-tickets-count", "allwyn-tickets-count"]),
    (_unref(isDefaultDrawDataLoaded) && _unref(isAllwynDrawDataLoaded))
      ? (_openBlock(), _createBlock(RafflePrizesModal, {
          key: 0,
          modelValue: isModalOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalOpen).value = $event)),
          "default-draw-win-table": _unref(defaultDrawData)?.winTable,
          "allwyn-draw": _unref(allwynDrawData),
          "btn-right-icon": "check"
        }, null, 8, ["modelValue", "default-draw-win-table", "allwyn-draw"]))
      : _createCommentVNode("", true)
  ]))
}
}

})